import { getLoginUrl } from "../services/apis/auth";
import { getRedirectUrl } from "./authentication";
import { isPinAuthGatePending } from "./pinBrowserFlags";

/** OAuth provider key for auto-login (VITE_AUTO_LOGIN_PROVIDER): GOOGLE, X or the backend provider's login key. */
export const getAutoLoginProvider = (): string => import.meta.env.VITE_AUTO_LOGIN_PROVIDER

export const redirectToAutoLogin = async (): Promise<void> => {
    if (isPinAuthGatePending()) return
    const url = await fetchLoginUrl(getAutoLoginProvider())
    if (isPinAuthGatePending()) return
    window.location.href = url
}

export const fetchLoginUrl = async (authProvider: string): Promise<string> => {
    const request = {
        body: {
            authProvider,
            params: [{ key: 'redirectUrl', value: getRedirectUrl(authProvider) }],
        },
    }
    return (await getLoginUrl(request)).url
}
